'use client';

import { useEffect } from 'react';

import { getMailerLiteIframeProxyScript } from '@/utils/mailerlite-iframe-proxy';

/** Wait until after load so MailerLite popups cannot become the LCP element. */
const MAILERLITE_BOOTSTRAP_IDLE_TIMEOUT_MS = 4000;

/**
 * Installs the MailerLite iframe proxy after the page load event. Must run before
 * universal.js creates popup iframes, but deferring until post-LCP avoids the
 * newsletter modal competing for LCP during Lighthouse runs.
 */
const MailerLiteSubscribeBootstrap = () => {
  useEffect(() => {
    const install = () => {
      if (document.getElementById('mailerlite-iframe-proxy')) return;

      const script = document.createElement('script');
      script.id = 'mailerlite-iframe-proxy';
      script.textContent = getMailerLiteIframeProxyScript();
      document.head.appendChild(script);
    };

    const schedule = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(install, { timeout: MAILERLITE_BOOTSTRAP_IDLE_TIMEOUT_MS });
      } else {
        setTimeout(install, MAILERLITE_BOOTSTRAP_IDLE_TIMEOUT_MS);
      }
    };

    if (document.readyState === 'complete') {
      schedule();
      return;
    }

    window.addEventListener('load', schedule, { once: true });
  }, []);

  return null;
};

export default MailerLiteSubscribeBootstrap;
